import { times } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ContentLoader from 'react-content-loader';

import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const CIRCLE_SIZE = 40;
const CIRCLE_OFFSET = 14.5;

const SQUARE_SIZE = 48;

function Circle({ offset, size = CIRCLE_SIZE }) {
  return (
    <circle className="DesktopSwatchListPlaceholder__circle" cx={offset} cy={22} r={size / 2} />
  );
}

function Square({ offset }) {
  return <rect x={offset} y={3} width={SQUARE_SIZE} height={SQUARE_SIZE} />;
}

const nCircles = 6;

function DesktopSwatchListPlaceholder({ ...props }) {
  const WIDTH = (CIRCLE_SIZE + CIRCLE_OFFSET) * nCircles;
  const HEIGHT = 60;

  return (
    <div className="DesktopSwatchListPlaceholder">
      <ContentLoader
        width={WIDTH}
        height={HEIGHT}
        speed={1}
        primaryColor={Theme.get('colors-black-20')}
        secondaryColor={Theme.get('colors-black-20')}
        animate={false}
        style={{ maxWidth: `${WIDTH}px` }}
        {...props}
      >
        {times(nCircles, i => (
          <Circle
            offset={22 + i * (CIRCLE_SIZE + CIRCLE_OFFSET + 2.5)}
            size={CIRCLE_SIZE}
            key={i}
          />
        ))}
      </ContentLoader>
      <style jsx>
        {`
          .DesktopSwatchListPlaceholder {
            display: auto;
            text-align: center;
            margin-bottom: ${Theme.get('spacing') * 3.5}px;
          }

          @media ${largeUp} {
            .DesktopSwatchListPlaceholder {
              text-align: left;
              margin-bottom: 0;
            }
          }
        `}
      </style>
    </div>
  );
}

Circle.propTypes = {
  offset: PropTypes.number,
  size: PropTypes.number,
};

Square.propTypes = {
  offset: PropTypes.number,
  size: PropTypes.number,
};

export default DesktopSwatchListPlaceholder;
